import { CLASS_FORM_TITLE } from 'modules/classManager/constants';
import { CONTENT_PAGE_TITLES } from 'modules/content/contentPageTitles';
import { TRACK_PAGE_TITLES } from 'modules/content/tracks/constants';
import { EDIT_SUBTITLE } from 'modules/subtitle/components/SubtitleEditor';
import { USER_IMPORT_TITLE } from 'modules/userManager/imports/components/UserImport';
import { USER_EDIT_TITLE } from 'modules/userManager/userDetail/UserDetail';

import { ROUTES } from '../constants';

const { CONTENT, CLASS, USER } = ROUTES;

const contentPageTitles = {
  [CONTENT.NEW_MODULE]: CONTENT_PAGE_TITLES.MODULE.NEW,
  [CONTENT.IMPORT]: CONTENT_PAGE_TITLES.MODULE.IMPORT,
  [CONTENT.EDIT_MODULE]: CONTENT_PAGE_TITLES.MODULE.EDIT,
  [CONTENT.ADD_CONTENT]: CONTENT_PAGE_TITLES.CONTENT.NEW,
  [CONTENT.EDIT_CONTENT]: CONTENT_PAGE_TITLES.CONTENT.EDIT,
  [CONTENT.REVIEW_SUBTITLE]: EDIT_SUBTITLE,
  [CONTENT.NEW_ADVERTISEMENT]: CONTENT_PAGE_TITLES.ADVERTISEMENT.NEW,
  [CONTENT.EDIT_ADVERTISEMENT]: CONTENT_PAGE_TITLES.ADVERTISEMENT.EDIT,
  [CONTENT.NEW_QUIZ]: CONTENT_PAGE_TITLES.QUIZ.NEW,
  [CONTENT.EDIT_QUIZ]: CONTENT_PAGE_TITLES.QUIZ.EDIT,
  [CONTENT.NEW_WEBINAR]: CONTENT_PAGE_TITLES.WEBINAR.NEW,
  [CONTENT.EDIT_WEBINAR]: CONTENT_PAGE_TITLES.WEBINAR.EDIT,
  [CONTENT.NEW_LIVE_MF]: CONTENT_PAGE_TITLES.WEBINAR.NEW,
  [CONTENT.EDIT_LIVE_MF]: CONTENT_PAGE_TITLES.WEBINAR.EDIT,
  [CONTENT.TRACKS]: TRACK_PAGE_TITLES.LIST,
  [CONTENT.NEW_TRACK]: TRACK_PAGE_TITLES.NEW,
  [CONTENT.EDIT_TRACK]: TRACK_PAGE_TITLES.EDIT,
  [CONTENT.VIEW_TRACK]: TRACK_PAGE_TITLES.VIEW
};

const classPageTitles = {
  [CLASS.NEW]: CLASS_FORM_TITLE.NEW,
  [CLASS.EDIT]: CLASS_FORM_TITLE.EDIT
};

const userPageTitles = {
  [USER.IMPORT]: USER_IMPORT_TITLE,
  [USER.DETAIL]: USER_EDIT_TITLE
};

export default { ...contentPageTitles, ...classPageTitles, ...userPageTitles };
